import React, {Component} from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar as StarSolid } from '@fortawesome/free-solid-svg-icons'
import { faStar as StarOutline} from '@fortawesome/free-regular-svg-icons'
import { faBuilding } from '@fortawesome/free-regular-svg-icons'
import { faCogs} from '@fortawesome/free-solid-svg-icons'
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons'
import { faCheckSquare } from '@fortawesome/free-regular-svg-icons'
import { faChartArea } from '@fortawesome/free-solid-svg-icons'
import ReactTable from "react-table-v6"

import 'react-table-v6/react-table.css'

const ListView = (props) => {
        console.log(props.searchResults)
        const columns = [
            {
                Header: '',
                accessor: 'favorite',
                maxWidth: 25,
                Cell: p => p.value ? <FontAwesomeIcon icon={StarSolid} /> : <FontAwesomeIcon icon={StarOutline} />
            }, {
                Header: 'Name',
                accessor: 'name',
            },{
                Header: '',
                accessor: 'spaces',
                maxWidth: 25,
                Cell: p => p.value && p.value > 0 ? <FontAwesomeIcon icon={faBuilding} /> : ""
            },{
                Header: '',
                accessor: 'equipment',
                maxWidth: 25,
                Cell: p => p.value && p.value > 0 ? <FontAwesomeIcon icon={faCogs} /> : ""
            },{
                Header: '',
                accessor: 'dashboards',
                maxWidth: 25,
                Cell: p => p.value && p.value > 0 ? <FontAwesomeIcon icon={faChartArea} /> : ""
            } ,{
                Header: '',
                accessor: 'schedules',
                maxWidth: 25,
                Cell: p => p.value && p.value > 0 ? <FontAwesomeIcon icon={faCalendarAlt} /> : ""
            },{
                Header: '',
                accessor: 'checklists',
                maxWidth: 25,
                Cell: p => p.value && p.value > 0 ? <FontAwesomeIcon icon={faCheckSquare} /> : ""
            }
        ]
         
        return (
            <div className="results-list-view">
                <ReactTable key={(props.searchResults && props.searchResults.length) || 0}
                    data={props.searchResults}
                    columns={columns}
                />
            </div>


        )
}

export default ListView;
